(() => {
  if (window.newsletterKlaviyoReady) return;
  window.newsletterKlaviyoReady = true;

  const subscribe = async (form) => {
    const email = form.querySelector('input[type="email"]')?.value.trim();
    if (!email) return false;
    const response = await fetch(
      `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(form.dataset.klaviyoCompany)}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/vnd.api+json",
          revision: "2024-10-15",
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              custom_source: "Footer signup",
              profile: {
                data: { type: "profile", attributes: { email } },
              },
            },
            relationships: {
              list: { data: { type: "list", id: form.dataset.klaviyoList } },
            },
          },
        }),
      },
    );
    return response.ok;
  };

  document.addEventListener("submit", async (event) => {
    const form = event.target.closest("form[data-klaviyo-company][data-klaviyo-list]");
    if (!form || !form.dataset.klaviyoCompany || !form.dataset.klaviyoList) return;
    event.preventDefault();
    const success = form.querySelector("[data-newsletter-success]");
    const error = form.querySelector("[data-newsletter-error]");
    const button = form.querySelector('[type="submit"]');
    if (success) success.hidden = true;
    if (error) error.hidden = true;
    if (button) button.disabled = true;
    try {
      const ok = await subscribe(form);
      if (ok) {
        form.reset();
        if (success) success.hidden = false;
      } else if (error) {
        error.hidden = false;
      }
    } catch {
      if (error) error.hidden = false;
    } finally {
      if (button) button.disabled = false;
    }
  });
})();
